module.exports = __webpack_public_path__ + "img/1.a929a8d8.jpg";